const TaskType = {
  Cold_Call: "Cold Call",
  Followup: "Follow up",
  Mail: "Mail",
  Meeting: "Meeting",
  Site_Visit: "Site Visit",
  Clouser_Meeting: "Clouser Meeting",
  Other: "Other",
  Planned: "Planned",
  Calling_Data: "Calling Data",
  Comment: "Comment",
};

const TaskStatus = {
  //Default
  Pending: "Pending",
  Missed: "Missed",
  //Fresh call Not Connected Status
  Not_Connected: "Not Connected",
  NoAnswer: "No Answer",
  Busy: "Busy",
  Invalid_Number: "Invalid Number",
  Callback: "Callback",

  //Fresh Call Connected Status
  Interested: "Interested",
  Not_Interested: "Not Interested",

  //Other Task type Status
  Positive: "Positive",
  Negative: "Negative",
  Neutral: "Neutral",
  Cancelled: "Cancelled",
  Rescheduled: "Rescheduled",
  //mail
  Completed: "Ready To Bill",
  Planned: "Planned",
};

export const isTaskCompletedAdded = (taskType, taskStatus) => {
  switch (taskType) {
    case TaskType.Cold_Call:
      return (
        taskStatus === TaskStatus.Interested ||
        taskStatus === TaskStatus.Not_Interested ||
        taskStatus === TaskStatus.Invalid_Number
      );
    case TaskType.Followup:
      return (
        taskStatus == TaskStatus.Positive ||
        taskStatus == TaskStatus.Negative ||
        taskStatus == TaskStatus.Neutral ||
        taskStatus == TaskStatus.Cancelled
      );
    case TaskType.Site_Visit:
      return (
        taskStatus == TaskStatus.Positive ||
        taskStatus == TaskStatus.Negative ||
        taskStatus == TaskStatus.Neutral ||
        taskStatus == TaskStatus.Cancelled
      );
    case TaskType.Meeting:
      return (
        taskStatus == TaskStatus.Positive ||
        taskStatus == TaskStatus.Negative ||
        taskStatus == TaskStatus.Neutral ||
        taskStatus == TaskStatus.Cancelled
      );
    case TaskType.Comment:
      return true;
    default:
      return false;
  }
};

export const leadColors = {
  Cold: "#F7A829",
  Warm: "#2EBDC5",
  Hot: "#28e175ff",
  Onhold: "#95a5a6",
  Win: "#087b1dff",
  Fresh: "#1abc9c",
  Marketing: "#f38131ff",
};
